import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  QSetSimilarityResultProvider,
  QSetSimilarityResultsHeader,
} from '@exam-management/qset-check-similarity-result';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QSetCheckSimilarityResultsLayout() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM.QSET.VIEW]}>
      <QSetSimilarityResultProvider>
        <Box
          sx={{
            minHeight: '100dvh',
          }}
        >
          <QSetSimilarityResultsHeader />
          <Outlet />
        </Box>
      </QSetSimilarityResultProvider>
    </PermissionGuard>
  );
}
